import { nextTick } from "vue";

import { removeBoardScrollMargin } from "@/math/coordinate-utils";
import { fakeZoom } from "@/model/Settings";
import type { ZoomedRectangle } from "@/model/board";
import { pushZoomState } from "@/router/navigation";
import { useBoardSizeStore } from "@/store/boardSize";

export function applyFluidBoardRect(rect: ZoomedRectangle) {
  const rightBottom = useBoardSizeStore().rightBottomMargin;
  applyBoardRect({
    scale: rect.zoom / fakeZoom,
    top: rect.p0.y + "px",
    left: rect.p0.x + "px",
    height: rect.size.y + "px",
    width: rect.size.x + "px",
    right: rightBottom.x + "px",
    bottom: rightBottom.y + "px",
  });
}

function applyBoardRect(size: {
  scale: number;
  top: string;
  left: string;
  height: string;
  width: string;
  bottom: string;
  right: string;
}) {
  const boardElem = document.getElementById("boards");
  const borderElem = document.getElementById("boards-border");
  if (boardElem && borderElem) {
    const boardStyle = boardElem.style;
    boardStyle.transform = `scale(${size.scale})`;
    boardStyle.top = size.top;
    boardStyle.left = size.left;
    boardStyle.height = size.height;
    boardStyle.width = size.width;

    const borderStyle = borderElem.style;
    borderStyle.transform = `scale(${1 / size.scale})`;
    borderStyle.height = size.bottom;
    borderStyle.width = size.right;
  }
}

export function keepBoardScrollPos(action: () => void) {
  // wait to assure useBoardSizeStore().board.p0.x is applied to DOM
  void nextTick(() => {
    const scrollPos = window.scrollX - useBoardSizeStore().board.p0.x;
    action();
    void nextTick(() => {
      window.scrollTo({ left: scrollPos + useBoardSizeStore().board.p0.x });
      pushZoomState();
    });
  });
}

export function resetBoardScrollMargin() {
  if (!useBoardSizeStore().scrollableMarginLocked) {
    keepBoardScrollPos(removeBoardScrollMargin);
  } else {
    pushZoomState();
  }
}
